import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useServices, useStores } from 'index';
import { CreateUpdateTrackmanParameterCategoryRequest } from 'types/admin/trackmanParameterCategories';
import { getErrorMessage } from 'utilities/ErrorHelper';

export const useCreateTrackmanParameterCategory = () => {
  const service = useServices().trackmanParameterCategoriesService;
  const queryClient = useQueryClient();
  const notificationsStore = useStores().notificationStore;

  return useMutation({
    mutationFn: (request: CreateUpdateTrackmanParameterCategoryRequest) => service.createCategory(request),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['adminTrackmanParameterCategories'] });
      notificationsStore.addToast('success', 'Category created successfully', 'success');
    },
    onError: (error) => notificationsStore.addToast('error', getErrorMessage(error), 'error'),
  });
};
